export const en = {
  toast: {
    error: {
      offlineModuleModelNotSaveable: "Offline saving not available",
    },
    success: {},
    warning: {},
  },
};
